import React from 'react'
import { InfoWindow, Marker, } from '@react-google-maps/api'
import MarkerInfoWindow from './MarkerInfoWindow'
import { getMarkerColorForAddrType, getMarkerUrl, inGreaterWA, } from '../../util/mapCalcs'
import PropTypes from 'prop-types'
import { noop, } from 'lodash'
import { MARKER_TYPES, } from '../../constants/other'

const ProgramMarker = ({
  activateProgram = null,
  active = false,
  address = '',
  checkWALocation = false,
  desc = '',
  index = null,
  lat = null,
  lng = null,
  name = '',
  progOccId = null,
  programType = null,
  resetActiveIndex = noop,
  setActiveIndex = noop,
  title = '',
  type = null,
  viewAction = null,
  viewUrl = null,
}) => {
  const latLng = { lat, lng, }
  const typeColor = getMarkerColorForAddrType(type)
  const url = (programType && type) ? getMarkerUrl(programType.toLowerCase(), type.toLowerCase()) : MARKER_TYPES[0]

  const icon = {
    url           : url,
    //path          : google.maps.SymbolPath.CIRCLE,
    fillColor     : typeColor,
    fillOpacity   : 1,
    strokeColor   : 'white',
    strokeOpacity : 1,
    strokeWeight  : 2,
    scaledSize    : new google.maps.Size(25, 25), // eslint-disable-line no-undef
    //scale         : 10, // todo: pass zoom level from hoc to scale
  }

  const onWindowCloseClick = React.useCallback((e) => {
    if (e) {
      e.preventDefault()
    }
    if (active){
      resetActiveIndex()
    }
  }, [ active, resetActiveIndex, ])

  const onMarkerClick = React.useCallback(() => {
    if (active) {
      resetActiveIndex()
    } else if (index !== undefined && index !== null) {
      setActiveIndex(index)
    } else {
      setActiveIndex()
    }
  }, [ active, index, resetActiveIndex, setActiveIndex, ])

  if (!lat || !lng) {
    return null
  }

  // WCOD-295: Locations outside continental US & southern Canada will not display
  if (lat < 23 || lat > 52 || lng < -130 || lng > -80 || (checkWALocation && !inGreaterWA(latLng))) {
    return null
  }
  
  return (
    <Marker position={latLng} onClick={onMarkerClick} icon={icon} aria-label={type}>
      { 
        active && <InfoWindow onCloseClick={onWindowCloseClick}>
          <MarkerInfoWindow 
            activateProgram={activateProgram}
            address={address}
            description={desc}
            name={name}
            progOccId={progOccId}
            programType={programType}
            title={title}
            type={type}
            viewAction={viewAction}
            viewUrl={viewUrl}
          />
        </InfoWindow>
      }
    </Marker>
  )
}

ProgramMarker.propTypes = {
  activateProgram  : PropTypes.func,
  active           : PropTypes.bool,
  address          : PropTypes.string,
  checkWALocation  : PropTypes.bool,
  desc             : PropTypes.string,
  index            : PropTypes.number,
  lat              : PropTypes.oneOfType([ PropTypes.string, PropTypes.number, ]),
  lng              : PropTypes.oneOfType([ PropTypes.string, PropTypes.number, ]),
  name             : PropTypes.string,
  progOccId        : PropTypes.oneOfType([ PropTypes.string, PropTypes.number , ]),
  programType      : PropTypes.string,
  resetActiveIndex : PropTypes.func,
  setActiveIndex   : PropTypes.func,
  title            : PropTypes.string,
  type             : PropTypes.string,
  viewAction       : PropTypes.func,
  viewUrl          : PropTypes.string,
}

export default React.memo(ProgramMarker)